
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Boxplot/index.md?watch=parent';
    export const demoIndex = {
  ids: ["boxplot-demo-common","boxplot-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__Boxplot" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Boxplot/index.md?type=demo')
};